module.exports = __webpack_public_path__ + "img/home-campaigns.cd663e00.png";